import Vue from 'vue'
import { toastError } from '@/libs/toastification'
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'

export default function usePackingMaterialsFetcher(vm) {
  const state = Vue.observable({
    fetcher: undefined,
  })

  const initializeFetcherPackingMaterials = () => {
    const fnFetch = ({
      offset, limit, search, cancelToken,
    }) => vm.$http_new.get('/komship/api/v1/packing-materials', {
      params: {
        offset,
        limit,
        search,
      },
      cancelToken,
    }).then(res => {
      const { data } = res.data
      const mappedData = data.map(item => ({
        name: item.name,
        layer: 0,
        id: item.id,
      }))
      return {
        data: mappedData,
      }
    }).catch(error => {
      if (vm.$http_new?.isCancel?.(error) || error?.name === 'CanceledError' || error?.name === 'AbortError' || error?.code === 'ERR_CANCELED') {
        throw error
      }
      console.error(error)
      toastError('Gagal mengambil data bahan packing, silahkan coba lagi')
      return {
        data: [],
      }
    })

    state.fetcher = createPaginatedFetcher(fnFetch, 0, 50)
  }

  return {
    state,
    initializeFetcherPackingMaterials,
  }
}
